import { storeToRefs } from 'pinia';

import { useToast } from 'primevue/usetoast';
import { useFormulaBuilderStore } from '@/store/formula/formulaBuilder';

const useFormulaBuilderComposable = () => {
    const toast = useToast();
    const { draggedAttribute, currentLayout, shared, currX, currY, index, colNum } = storeToRefs(useFormulaBuilderStore());
    const { setDraggedAttribute, setActiveItem } = useFormulaBuilderStore();

    const getOperatorValue = (opt) => {
        switch (opt) {
            case '+':
                return 'plus';
            case '-':
                return 'minus';
            case '*':
                return 'multiplied by';
            case '/':
                return 'divided by';
            case '==':
                return 'equals to';
            case '<=':
                return 'less than or equals to';
            case '>=':
                return 'greater than or equals to';
            case '!=':
                return 'not equal to';
            // returns constant values in default case
            default:
                return opt;
        }
    };

    const formulaJsonToLayout = (jsonValue) => {
        // clean the existing layout before loading new ones
        currentLayout.value = [];
        currX.value = 0;
        currY.value = 0;
        index.value = 0;
        jsonValue.forEach((item) => {
            const key = Object.keys(item)[0];
            const value = item[key];
            addItem(value, key);
        });
    };
    const addItem = (dataVal, type = 'value') => {
        if (currX.value >= colNum.value) {
            currX.value = 0;
            currY.value++;
        }
        // Add a new item. It must have a unique key!
        const newLayout = {
            x: currX.value++,
            y: currY.value,
            w: 1,
            h: 1,
            i: index.value,
            type,
        };
        // in case of attribute types, uses code, otherwise value
        if (type == 'code') {
            newLayout.code = dataVal;
        } else {
            newLayout.value = dataVal;
        }
        currentLayout.value.push(newLayout);
        setActiveItem(newLayout);
        // Increment the counter to ensure key is always unique.
        index.value++;
    };

    const getFormattedFormulaArray = () => {
        try {
            const formattedFormula = [];
            if (currentLayout.value?.length > 0) {
                currentLayout.value.map((item) => {
                    const key = item.type;
                    const value = item.code ?? item.value;
                    const newObj = { [key]: value };
                    formattedFormula.push(newObj);
                });
            }
            return formattedFormula;
        } catch (error) {
            toast.add({ severity: 'error', summary: 'Error', detail: error ?? 'Something went wrong', life: 5000 });
        }
    };

    const getFormattedCodeValueArray = () => {
        try {
            const formattedCodeValueArr = [];
            if (currentLayout.value?.length > 0) {
                currentLayout.value
                    .filter((item) => item.type == 'code')
                    .map((item) => {
                        const newObj = { code: item.code, value: '10' };
                        formattedCodeValueArr.push(newObj);
                    });
            }
            return formattedCodeValueArr;
        } catch (error) {
            toast.add({ severity: 'error', summary: 'Error', detail: error ?? 'Something went wrong', life: 5000 });
        }
    };

    const getTestFormulaBody = (sortedLayoutArr) => {
        const currentValues = getFormattedCodeValueArray();
        const formula = sortedLayoutArr
            .map((item) => {
                return item.code ?? item.value;
            })
            .join('');
        return {
            values: currentValues,
            formula: formula,
        };
    };

    return {
        draggedAttribute,
        setDraggedAttribute,
        shared,
        currentLayout,
        getOperatorValue,
        getFormattedFormulaArray,
        getTestFormulaBody,
        addItem,
        formulaJsonToLayout,
    };
};

export default useFormulaBuilderComposable;
